var React = require('react');

function Down (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 4.5L7.5 1L6.5 8.74228e-08L4 2.5L1.5 5.24537e-07L0.5 1L4 4.5Z","fill":"#A5AEB6"}));
}

Down.defaultProps = {"width":"8","height":"5","viewBox":"0 0 8 5","fill":"none"};

module.exports = Down;

Down.default = Down;
